import { createFileRoute } from '@tanstack/react-router'
import { aiUsageSearchSchema } from '../../../../features/settings/ai-search'
import { AiUsagePage } from '../../../../features/settings/ai-usage-page'
import { requireSection } from '../../../../features/settings/guards'

/** Settings › AI assistant › Usage and runs (ai.manage): tokens against the limit, and run metadata. */
export const Route = createFileRoute('/_app/settings/ai/usage')({
  staticData: { crumb: 'settingsSection' },
  validateSearch: aiUsageSearchSchema,
  beforeLoad: ({ context }) => requireSection(context.session, 'ai'),
  component: AiUsagePage,
})
